'use client';

import { HubErrorView } from '@/components/errors/AreaErrorViews';

/** A failed hub page, inside the hub shell so the rail and tab bar stay. */
export default function HubError({ error }: { error: Error & { digest?: string } }) {
  return <HubErrorView error={error} />;
}
